export const dialogPaperSx = {
  borderRadius: '4px',
  overflow: 'hidden'
};

export const headerSx = {
  p: 1.5,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-between',
  borderBottom: '1px solid #E0E0E0'
};

export const titleSx = {
  fontSize: 17,
  fontWeight: 500,
  color: '#424242'
};

export const subtitleSx = {
  fontSize: 12,
  color: '#424242'
};

export const closeButtonSx = {
  p: 0.75,
  color: '#424242'
};

export const dialogContentSx = {
  p: 1.5
};

export const patientBoxSx = {
  p: 1.5,
  mb: 2,
  bgcolor: '#E6F2F9',
  border: '1px solid #C1DEF2',
  borderRadius: '6px'
};

export const compactPatientBoxSx = {
  p: 1,
  mb: 2,
  bgcolor: '#E6F2F9',
  border: '1px solid #C1DEF2',
  borderRadius: '6px'
};

export const patientNameSx = {
  fontSize: 14,
  fontWeight: 500,
  color: '#424242'
};

export const compactPatientNameSx = {
  fontSize: 14,
  fontWeight: 500,
  color: '#212121'
};

export const patientMrSx = {
  mt: 0.25,
  fontSize: 13,
  color: '#616161'
};

export const compactPatientMrSx = {
  mt: 0,
  fontSize: 11,
  color: '#212121'
};

export const sectionTitleSx = {
  fontSize: 13,
  fontWeight: 600,
  color: '#424242'
};

export const compactSectionTitleSx = {
  fontSize: 13,
  fontWeight: 500,
  color: '#424242',
  textTransform: 'uppercase'
};

export const metaTextSx = {
  fontSize: 12,
  color: '#616161'
};

export const bodyTextSx = {
  mb: 2,
  fontSize: 14,
  color: '#616161',
  lineHeight: 1.5
};

export const providerResponseSectionSx = {
  pt: 2,
  borderTop: '1px solid #E0E0E0'
};

export const providerResponseTextSx = {
  my: 2,
  fontSize: 14,
  color: '#616161',
  lineHeight: 1.5
};

export const formControlSx = {
  mt: 2,

  '& .MuiInputLabel-root': {
    fontSize: 13,
    color: '#757575'
  },

  '& .MuiInputLabel-root.Mui-focused': {
    color: '#1976D2'
  },

  '& .MuiOutlinedInput-root': {
    height: 38,
    bgcolor: '#fff',
    borderRadius: '4px',
    fontSize: 13
  },

  '& .MuiSelect-select': {
    py: 1
  }
};

export const issueHeaderSx = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between'
};

export const editIconSx = {
  color: '#757575',
  fontSize: 20
};

export const issueTextSx = {
  mb: 2,
  fontSize: 13,
  color: '#616161',
  lineHeight: 1.5
};

export const responseFieldSx = {
  '& .MuiOutlinedInput-root': {
    alignItems: 'flex-start',
    bgcolor: '#fff',
    borderRadius: '4px',
    fontSize: 13
  },

  '& .MuiInputBase-inputMultiline': {
    fontSize: 13,
    lineHeight: 1.5,
    color: '#424242'
  },

  '& .MuiInputLabel-root': {
    fontSize: 13
  }
};

export const recommendationWrapperSx = {
  mt: 2,
  pt: 2,
  borderTop: '1px solid #E0E0E0'
};

export const recommendationSelectSx = {
  height: 42,
  bgcolor: '#fff',
  borderRadius: '4px',
  fontSize: 13
};

export const menuProps = {
  slotProps: {
    paper: {
      sx: {
        borderRadius: '4px',
        boxShadow: '0px 4px 16px rgba(0,0,0,0.16)',
        fontSize: 13,

        '& .MuiMenu-list': {
          p: 0
        },

        '& .MuiMenuItem-root': {
          minHeight: 38,
          fontSize: 13,
          color: '#424242',

          '&:hover': {
            bgcolor: '#FCF8F2'
          },

          '&.Mui-selected': {
            bgcolor: '#fff'
          },

          '&.Mui-selected:hover': {
            bgcolor: '#FCF8F2'
          },

          '&.Mui-focusVisible': {
            bgcolor: '#FFF8ED'
          }
        }
      }
    }
  }
};

export const dialogActionsSx = {
  px: 2.5,
  py: 2,
  gap: 1.5,
  borderTop: '1px solid #E0E0E0'
};

export const cancelButtonSx = {
  height: 38,
  px: 2,
  color: '#616161',
  fontSize: 13,
  fontWeight: 500,
  textTransform: 'uppercase'
};

export const submitButtonSx = {
  height: 38,
  px: 2,
  bgcolor: '#5697D4',
  borderRadius: '4px',
  color: '#fff',
  boxShadow: 'none',
  fontSize: 13,
  fontWeight: 500,
  textTransform: 'uppercase',

  '&:hover': {
    bgcolor: '#1976D2',
    boxShadow: 'none'
  },

  '&.Mui-disabled': {
    bgcolor: '#E9E9E9',
    color: '#BDBDBD'
  }
};

export const stepperSx = {
  '& .MuiStep-root': {
    p: 0
  },

  '& .MuiStepLabel-root': {
    p: 0,
    alignItems: 'center'
  },

  '& .MuiStepLabel-iconContainer': {
    p: 0,
    pr: 2
  },

  '& .MuiStepLabel-label': {
    fontSize: 14,
    fontWeight: 600,
    color: '#424242 !important'
  }
};

export const completedIconSx = {
  color: '#4CAF50',
  fontSize: 22
};

export const getStepContentSx = isLastStep => ({
  ml: '11px',
  pl: 3.5,
  pb: 1.5,
  borderLeft: isLastStep
    ? 'none'
    : '1px solid #BDBDBD'
});

export const stepMetaSx = {
  fontSize: 12,
  color: '#616161'
};

export const stepUserSx = {
  mb: 1,
  fontSize: 12,
  color: '#424242'
};

export const personIconSx = {
  mr: 0.5,
  fontSize: 16,
  verticalAlign: 'middle'
};

export const stepContentBoxSx = {
  p: 1,
  bgcolor: '#FCF8F2',
  borderLeft: '3px solid #F8F1E2',
  borderRadius: 1
};

export const stepContentTextSx = {
  fontSize: 12,
  color: '#424242',
  lineHeight: 1.6
};